// start:ng42.barrel
import './colour-picker.component';
// end:ng42.barrel

